import {Component, Input, OnInit} from '@angular/core';
import {
  FormArray, FormBuilder, FormControl, FormGroup,
  Validators
} from "@angular/forms";
import {TestRackService} from "app/modules/models/test-rack/services/test-rack.service";
import {NotificationsService} from "@catcore/services";
import {extractDataFromModel} from "@catcore/utils";
import {Observable} from "rxjs/Observable";
import {ZoneAssignmentService} from "@catmodules/models/test-rack/services/zone-assignment.service";

@Component({
  selector: 'catapp-test-rack-zone-assignment',
  templateUrl: './test-rack-zone-assignment.component.html',
  styleUrls: ['./test-rack-zone-assignment.component.scss']
})
export class TestRackZoneAssignmentComponent implements OnInit {

  form: FormGroup;
  subscription = null;
  private _testRackSetup = null;

  project = null;
  testRackZoneOptions = [];
  zoneAssignments = [];

  constructor(private testRackService: TestRackService,
              private formBuilder: FormBuilder,
              private zoneAssignmentService: ZoneAssignmentService,
              private notificationService: NotificationsService) {
    this.form = new FormGroup({
      testRackZoneSetup: this.formBuilder.array([])
    });
  }

  @Input()
  set testRackSetup(testRackSetup) {
    if (testRackSetup !== this._testRackSetup) {
      console.log('testrackSetup: ', testRackSetup);
      this.zoneAssignments = extractDataFromModel(testRackSetup, 'zone_assignments', '_embedded');
      this.updateZoneSetupForm();
      const subscr = this.testRackService.getAllSubresources(testRackSetup._embedded.test_rack.id, 'zones')
        .finally(() => subscr.unsubscribe())
        .subscribe((items) => {
          const itemList = [];

          items.forEach((item) => {
            itemList.push({label: item.name, value: item});
          });
          this.testRackZoneOptions = itemList;
          this.updateZoneSetupForm();
        });
    }
  }

  ngOnInit() {
  }

  onSubmit(event) {
    const requests = [];
    const updatedParams = [];

    const formArray = this.form.controls['testRackZoneSetup'] as FormArray;
    for (let i = 0; i < formArray.length; i++) {
      if (formArray.at(i).dirty) {
        const zoneAssignment = this.zoneAssignments[i];
        console.log('form control value :', formArray.at(i).value);
        const newZone = formArray.at(i).value.testRackZone;
        requests.push(this.zoneAssignmentService.update({
          id: zoneAssignment.id,
          test_rack_zone: newZone._links.self.href,
        }));
      }
    }

    const subscr = Observable.forkJoin(requests)
      .finally(() => subscr.unsubscribe())
      .subscribe((multiple) => {
        this.notificationService.success('Update successful', 'Successfully updated ' + multiple.length + ' zone assignments');
      })
    ;
  }

  private updateZoneSetupForm(): void {
    const formControls = [];
    if (this.zoneAssignments !== null) {
      this.zoneAssignments.sort((a,b) => a._links.gui_zone.label.localeCompare(b._links.gui_zone.label));
      this.zoneAssignments.forEach((model) => {
        formControls.push(this.formBuilder.group({
          testRackZone: new FormControl(this.findTestRackZoneOption(
            model._links.test_rack_zone.href),
            [Validators.required]),
        }));
      });
    }

    this.form.setControl('testRackZoneSetup', this.formBuilder.array(formControls));
  }

  private findTestRackZoneOption(link) {
    if (this.testRackZoneOptions !== null) {
      let result = this.testRackZoneOptions.find((zone) => {
        return zone.value._links.self.href === link;
      });
      if (result) {
        return result.value;
      }
    }
    return null;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/test-rack/components/test-rack-zone-assignment/test-rack-zone-assignment.component.ts